import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Home, User, Layers, Compass } from 'lucide-react';

const mocks = [
  { path: '/preview/redraft-v2/home',        icon: Home,    title: 'Home — full rewrite',       desc: 'New §2 "Transform Your Project Delivery", new §3 "Sound Familiar?", Platform/Process/People pillars, Markets strip, final CTA re-headlined.', live: '/' },
  { path: '/preview/redraft-v2/about',       icon: User,    title: 'About — full rewrite',      desc: '"Why Organisations Choose Keystone" — 7 reasons with one-line explanations, plus the unchanged practitioner-built narrative.', live: '/about' },
  { path: '/preview/redraft-v2/platform',    icon: Layers,  title: 'Platform — opener + features', desc: '"Sound Familiar?" pain-point opener moved here, plus the 4 capability cards from the old home page (Stage-gated · Audit-ready · AI reporting · Bespoke).', live: '/platform' },
  { path: '/preview/redraft-v2/consultancy', icon: Compass, title: 'Consultancy — full rewrite', desc: '"What We Deliver" 7 disciplines, "How We Work Together" 4 engagement models (Advisory · Workshops · Embedded · Programme).', live: '/consultancy' },
];

const PreviewHub = () => (
  <div className="bg-slate-50 min-h-screen" data-testid="preview-hub">
    <section className="pt-16 pb-12 md:pt-24 md:pb-16 bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-900 text-[11px] uppercase tracking-[0.2em] font-semibold px-3 py-1.5 rounded-full mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse" /> Preview mode · Redraft v2
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-slate-900 leading-tight max-w-3xl">
          Updated web script — visual mock-ups for review.
        </h1>
        <p className="mt-6 text-lg text-slate-600 max-w-2xl leading-relaxed">
          Each card opens a fully-rendered page. Nothing here is live yet. Reply with which mocks
          you approve and I&apos;ll promote them to production in one commit.
        </p>
      </div>
    </section>

    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-5">
        {mocks.map((m) => (
          <Link
            key={m.path}
            to={m.path}
            className="group bg-white border border-slate-200 rounded-2xl p-6 md:p-7 hover:border-slate-900 transition-all shadow-sm hover:shadow-md"
          >
            <div className="flex items-start gap-4">
              <span className="w-11 h-11 rounded-lg bg-blue-50 border border-blue-100 text-blue-600 flex items-center justify-center flex-shrink-0">
                <m.icon className="w-5 h-5" />
              </span>
              <div className="flex-1 min-w-0">
                <h2 className="text-lg md:text-xl font-medium text-slate-900 leading-snug">{m.title}</h2>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{m.desc}</p>
                <div className="mt-4 flex items-center gap-4 text-xs">
                  <span className="inline-flex items-center text-blue-600 font-medium group-hover:translate-x-0.5 transition-transform">
                    Open mock-up <ArrowRight className="ml-1 w-3.5 h-3.5" />
                  </span>
                  <Link to={m.live} onClick={(e) => e.stopPropagation()} className="text-slate-500 hover:text-slate-900 underline">
                    Compare with live
                  </Link>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  </div>
);

export default PreviewHub;
